var _circle, _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBookingEmptyState(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 32,
    fill: "#A0CFDC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.5564 17.6934H16.7923C15.6471 17.6934 14.7187 18.7754 14.7187 20.1103L14.7187 44.9422C14.7187 46.277 15.6471 47.3591 16.7923 47.3591H48.5564C49.7016 47.3591 50.6299 46.277 50.6299 44.9422L50.6299 20.1103C50.6299 18.7754 49.7016 17.6934 48.5564 17.6934Z",
    stroke: "#0F2A59",
    strokeWidth: 1.48,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9102 21.2845V15.0391",
    stroke: "#0F2A59",
    strokeWidth: 1.48,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3008 21.2845V15.0391",
    stroke: "#0F2A59",
    strokeWidth: 1.48,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0391 25.5L50.6379 25.5",
    stroke: "#0F2A59",
    strokeWidth: 1.48,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2809 35.9627L30.2747 40.5759C30.3611 40.6757 30.5152 40.678 30.6045 40.5808L39.1816 31.2477",
    stroke: "#0F2A59",
    strokeWidth: 1.48,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookingEmptyState);
export default __webpack_public_path__ + "static/media/booking-emptyState.2059876a3eb674ca191014d8430d78d8.svg";
export { ForwardRef as ReactComponent };